const img = require('./ActiveUpgrades.svg'); export default img;